import React, { useEffect, useState } from "react";
import "./QuizHub.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// import { faArrowRight, faInfoCircle } from '@fortawesome/free-solid-svg-fields';
import bc from "../../images/book-cover.svg";
import com from "../../images/compass-icon.svg";
import sh from "../../images/shield.svg";
import { END_URL, IMG_URL, SITE_URL } from "../../config";
import axios from "axios";
import ff from "../../images/pp-logo.gif";
import Subscriptions from "../Subscriptions/Subscriptions";

function QuizHub({token,onsignup,onLoginChange,userdetail}) {

  const [loading, setLoading] = useState(true);

    const [quiz, setquiz] = useState([]);

    const [pageDetail, setpageDetail] = useState([]);

    const [error, setError] = useState("");

    const [ShowModal, setShowModal] = useState(false);

    const subS = true;

    const [subscription, setSubscription] = useState(null);

    const LoginShow = () => {

        window.scrollTo({ top: 0, behavior: 'smooth' });
        onsignup(true); 
    };

    useEffect(() => {

        fetchQuiz();

    }, []);

    const fetchQuiz = async () => {

        try {

            setLoading(true);

            const response = await axios.get(

                `${END_URL}/quiz-list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data.success) {

                setquiz(response.data.data || []);

                setpageDetail(response.data.page_detail||[]);

            } else {

                setError("Failed to load ebooks");
            }

        } catch (error) {

            console.log(error);

            setError("Something went wrong");

        } finally {

            setLoading(false);
        }
    };


    const handleSub = async (subJson) => {
        try {
          let subIds = [];
    
          if (typeof subJson === "string") {
            try {

              subIds = JSON.parse(subJson);

            } catch (e) {

              console.error("Invalid JSON string for subIds:", e);
              return;
            }
          } else if (Array.isArray(subJson)) {
            subIds = subJson;
          }
    
          setShowModal(true);
    
          const res = await axios.post(
            `${END_URL}/sub_adver`,
            { ids: subIds },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
    
          setSubscription(res.data);
    
          localStorage.removeItem("pendingSubIds");
        } catch (err) {
          console.error("Error loading subscriptions:", err);
        }
    };

    if (loading) {  

        return (
            <div className="loadingDiv">
                <img src={ff} alt="Loading..." />
            </div>
        );
    }

  return (
    <>

    <div className="quizhub-cont">
      <div className="ques-main quizhub-cont-banner">
        <div className="container-fluid">
          <div className="row ques-row">
            <div className="col-12">

              <div className="ques-top" style={{'--bg-image': `url(${IMG_URL}/d0/${pageDetail?.quiz_list_banner_image})` }} >

                <div className="ques-top-title" dangerouslySetInnerHTML={{__html:pageDetail?.quiz_list_banner_content}} />
            
              </div>

            </div>
          </div>
        </div>
      </div>

      <div className="container">

        <div className="row quizhub-book-cards-row">

          {quiz?.map((item, index) => {

            return (

                  item?.quizlist?.quiz_image && item?.quizlist?.quiz_image && (

                    <div className="col-md-4">

                      <div className="quiz-box">

                        <div className="quiz-imgDiv">

                          <img src={`${IMG_URL}/d0/${item?.quizlist?.quiz_image}`} alt="" />

                        </div>

                        {item?.quizlist?.main_quiz == 1 && (

                          <span className="quiz-top">MAIN QUIZ</span>

                        )}

                        <div className="quizhub-content">

                          <h6>{item?.quizlist?.test_show_name}</h6>
                          
                          <div dangerouslySetInnerHTML={{__html:item?.quizlist?.quiz_description}}/>
                          
                          <div className="quizhub-btn">

                            {token || item?.free_result == 1 || item?.type =='free_test' || item?.dilemma ==1 ? (
                              
                                item?.free_result == 1 || item?.type =='free_test' || item?.dilemma ==1 ? (

                                  <a class="new-commom-btn quizhub-take"

                                      href={
                                        item?.dilemma == 1
                                          ? `/dilemma/${item?.slug}`
                                          : item?.up_sell
                                          ? `/${item?.slug}`
                                          : `/test/${item?.slug}`
                                      }
                                  >

                                    <span>{pageDetail?.quiz_take_now_button_label}</span>

                                    <span class="righ-arr">
                                      <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                  </a>

                                ):(

                                    <a onClick={() =>handleSub(item?.sub_ids)}  class="new-commom-btn quizhub-take">

                                      <span>{pageDetail?.quiz_take_now_button_label}</span>

                                      <span class="righ-arr">
                                        <FontAwesomeIcon icon={faArrowRight} />
                                      </span>
                                    </a>
                                )

                            ):(
                                 <a onClick={() =>LoginShow()} class="new-commom-btn quizhub-take">

                                    <span>{pageDetail?.quiz_take_now_button_label}</span>

                                    <span class="righ-arr">
                                      <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>
                            )}

                            <a href={`${item?.quizlist?.about_quiz_link}`} class="new-commom-btn quiz-about">

                              <span>{pageDetail?.about_quiz_button_label}</span>

                              <span class="righ-arr">
                                <FontAwesomeIcon icon={faInfoCircle} />
                              </span>
                            </a>
                          </div>

                        </div>
                      </div>
                    </div>

                  )

                );
          })}

        </div>

        <div className="row ">
          <div className="adapter-cta-div adapter-cta-div-in-ebook">
            <div className="adapt-cta-img">
              <div>
                <span>
                  <img src={`${IMG_URL}/d0/${pageDetail?.quiz_footer_image}`} alt="" />
                </span>
              </div>
            </div>

            <div className="adapt-cta-text" dangerouslySetInnerHTML={{__html:pageDetail?.quiz_footer_content}}/>
        
            <div className="adapt-cta-btn">

              {pageDetail?.quiz_footer_start_button_label && pageDetail?.quiz_footer_start_button_link && (

                <a href={`${pageDetail?.quiz_footer_start_button_link}`} class="new-commom-btn adapter-btn">

                  <span>{pageDetail?.quiz_footer_start_button_label}</span>

                  <span class="righ-arr">

                    <FontAwesomeIcon icon={faArrowRight} />
                  </span>
                </a>

              )}

            </div>
          </div>
        </div>
      </div>

      <div className="quizhub-unique">
        <div className="container">
          <div className="row quizhub-unique-outer-row">

            {pageDetail?.quiz_badege_content_1 && (

               <div className="col-md-3">
                    <div className="quizhub-unibox">
                        <span>
                          <img src={`${IMG_URL}/d0/${pageDetail?.quiz_badege_icon_1}`} alt="" />
                        </span>

                        <div dangerouslySetInnerHTML={{__html:pageDetail?.quiz_badege_content_1}} />
                        

                    </div>
                </div>
            )}

            {pageDetail?.quiz_badege_content_2 && (

               <div className="col-md-3">
                    <div className="quizhub-unibox">
                        <span>
                          <img src={`${IMG_URL}/d0/${pageDetail?.quiz_badege_icon_2}`} alt="" />
                        </span>

                        <div dangerouslySetInnerHTML={{__html:pageDetail?.quiz_badege_content_2}} />
                        

                    </div>
                </div>
            )}

            {pageDetail?.quiz_badege_content_3 && (

               <div className="col-md-3">
                    <div className="quizhub-unibox">
                        <span>
                          <img src={`${IMG_URL}/d0/${pageDetail?.quiz_badege_icon_3}`} alt="" />
                        </span>

                        <div dangerouslySetInnerHTML={{__html:pageDetail?.quiz_badege_content_3}} />
                        

                    </div>
                </div>
            )}

              {pageDetail?.quiz_badege_content_4 && (

                <div className="col-md-3">
                      <div className="quizhub-unibox">
                          <span>
                            <img src={`${IMG_URL}/d0/${pageDetail?.quiz_badege_icon_4}`} alt="" />
                          </span>

                          <div dangerouslySetInnerHTML={{__html:pageDetail?.quiz_badege_content_4}} />
                          

                      </div>
                  </div>
              )}


          </div>
        </div>
      </div>
    </div>


    {ShowModal && (
          <div
            className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
              subscription?.data?.length == 1 ? "single-subscription" : ""
            }`}
          >
            <div className="newdashpop-inner">
              <div className="newdashpop-container">
                <button
                  className="newdashpop-close"
                  onClick={() => setShowModal(false)}
                >
                  &times;
                </button>

                <div className="conent-pop">
                  <Subscriptions
                    subs={subS}
                    userdetail={userdetail}
                    force_to_disable={false}
                    Subcription={subscription}
                    onLoginChange={onLoginChange}
                    free_popup={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
}

export default QuizHub;
